import React from "react";

const CustomTextArea = ({ id, label, register, className, error, ...rest }) => {
  return (
    <>
      <div className="relative mb-5">
        <textarea
          id={id}
          className={`peer border border-gray-300 rounded-[10px] py-2 h-full min-h-36 px-4 w-full placeholder-gray_600 placeholder:font-light focus:placeholder-transparent focus-visible:outline-primary_orange ${className}`}
          {...rest}
          {...register}
        />
        <label
          htmlFor={id}
          className="absolute top-[7px] left-3 bg-white px-1 text-lg font-normal text-primary_800 transition-all duration-300 transform -translate-y-1/2 scale-75 origin-left opacity-0 peer-focus:scale-75 peer-focus:-translate-y-5 peer-focus:opacity-100"
        >
          {label}
        </label>
        {error && <p className="text-red-500 text-xs pt-2">{error?.message}</p>}
      </div>
    </>
  );
};

export default CustomTextArea;
